// extracted by mini-css-extract-plugin
export default {"select":"Select_select__sR0AN","label":"Select_label__pyUrR","dropdown":"Select_dropdown__cFBZP"};